module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/programmatic-selection/programmatic-selection.component.css
// module id = ./src/app/examples/programmatic-selection/programmatic-selection.component.css
// module chunks = main